/**
 * Effective MODEX for a fleet aircraft.
 * Uses a stored override when present (T-44s); otherwise last 3 digits of BUNO.
 */
export function getAircraftModex(aircraft) {
    if (!aircraft) return '';
    const stored = (aircraft.effective_modex || aircraft.modex || '').toString().trim();
    if (stored) return stored;
    const buno = (aircraft.buno || '').toString();
    return buno.length >= 3 ? buno.slice(-3) : buno;
}
